import { AutoMap } from "@automapper/classes";

export class CountryDto {

    @AutoMap()
  public id!: string;

    @AutoMap()
    public code!: string;

    @AutoMap()
    public description!: string;

}